import React from 'react';
import PropTypes from 'prop-types';

import { PATH } from '../../../../constants/path';

import LinkButtonComponent from '../../../button/LinkButtonComponent';

const BackToEbonsButton = ({ text }) => (
    <LinkButtonComponent
        to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
        text={text}
        title={text}
        color="main"
    />
);

BackToEbonsButton.propTypes = {
    text: PropTypes.string.isRequired
};

export default BackToEbonsButton;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/BackToEbonsButton.js